// File: /src/hooks/useClientData.js

import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { AuthError } from '../utils/auth';
import { API_ENDPOINTS } from '../constants/apiEndpoints';
import apiClient from '../services/apiClient';

export const useClientData = () => {
	const [clients, setClients] = useState([]);
	const [services, setServices] = useState([]);
	const [invoices, setInvoices] = useState([]);
	const [selectedClients, setSelectedClients] = useState([]);
	const [loading, setLoading] = useState({
		clients: false,
		services: false,
		invoices: false,
	});

	// Função para buscar os clientes
	const refreshClients = async () => {
		setLoading((prev) => ({ ...prev, clients: true }));
		try {
			const response = await apiClient.get(
				API_ENDPOINTS.CLIENTS,
				
			);
			const sorted = response.data.sort((a, b) =>
				a.name.localeCompare(b.name)
			);
			setClients(sorted);
		} catch (err) {
			if (err instanceof AuthError) {
				return;
			}
			console.error('Erro ao carregar clientes:', err);
			toast.error('Erro ao carregar clientes.');
		} finally {
			setLoading((prev) => ({ ...prev, clients: false }));
		}
	};

	// Função para buscar os projetos/projetos
	const refreshProjects = async () => {
		setLoading((prev) => ({ ...prev, services: true }));
		try {
			const response = await apiClient.get(
				API_ENDPOINTS.PROJECTS,
				
			);
			setServices(response.data);
			return response.data;
		} catch (err) {
			if (err instanceof AuthError) {
				return;
			}
			console.error('Erro ao carregar projetos:', err);
			toast.error('Erro ao carregar projetos.');
			return null;
		} finally {
			setLoading((prev) => ({ ...prev, services: false }));
		}
	};

	// Função para buscar as faturas
	const refreshInvoices = async () => {
		setLoading((prev) => ({ ...prev, invoices: true }));
		try {
			const response = await apiClient.get(
				API_ENDPOINTS.INVOICES,
				
			);
			setInvoices(response.data);
		} catch (err) {
			if (err instanceof AuthError) {
				return;
			}
			console.error('Erro ao carregar faturas:', err);
			toast.error('Erro ao carregar faturas.');
		} finally {
			setLoading((prev) => ({ ...prev, invoices: false }));
		}
	};

	// Carregar dados ao montar o componente
	useEffect(() => {
		// Carregar todos os dados em paralelo para melhor performance
		Promise.all([
			refreshClients(),
			refreshProjects(),
			refreshInvoices(),
		]);
	}, []);

	// Função para alternar seleção de cliente
	const toggleSelectClient = (clientId) => {
		setSelectedClients((prevSelected) =>
			prevSelected.includes(clientId)
				? prevSelected.filter((id) => id !== clientId)
				: [...prevSelected, clientId]
		);
	};

	return {
		clients,
		services,
		invoices,
		selectedClients,
		setSelectedClients,  // Make sure this is exposed
		loading,
		refreshClients,
		refreshProjects,
		refreshInvoices,
		toggleSelectClient,
	};
};

export default useClientData;
